import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Landing from '@/pages/Landing';
import Engineering from '@/pages/Engineering';
import CreatePart from '@/pages/CreatePart';
import EditPart from '@/pages/EditPart';
import CreateWorksOrder from '@/pages/CreateWorksOrder';
import EditWorksOrder from '@/pages/EditWorksOrder';
import KanbanBoard from '@/pages/KanbanBoard';
import Inventory from '@/pages/Inventory';
import Schedule from '@/pages/Schedule';
import Dashboard from '@/pages/Dashboard';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import AdminUsers from '@/pages/AdminUsers';
import CalibrationModule from '@/components/CalibrationModule';
import CertificateManager from '@/components/CertificateManager';
import ExternalNcrView from '@/pages/ExternalNcrView';
import CustomerOrderHistory from '@/pages/CustomerOrderHistory';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/ncr/external/:token" element={<ExternalNcrView />} />
            
            {/* Protected Routes */}
            <Route path="/" element={<ProtectedRoute><Landing /></ProtectedRoute>} />
            <Route path="/engineering" element={<ProtectedRoute><Engineering /></ProtectedRoute>} />
            <Route path="/engineering/create" element={<ProtectedRoute><CreatePart /></ProtectedRoute>} />
            <Route path="/engineering/edit/:partNumber" element={<ProtectedRoute><EditPart /></ProtectedRoute>} />
            <Route path="/works-order/create" element={<ProtectedRoute><CreateWorksOrder /></ProtectedRoute>} />
            <Route path="/works-order/edit/:orderNumber" element={<ProtectedRoute><EditWorksOrder /></ProtectedRoute>} />
            <Route path="/kanban" element={<ProtectedRoute><KanbanBoard /></ProtectedRoute>} />
            <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
            <Route path="/schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>} />
            <Route path="/calibration" element={<ProtectedRoute><CalibrationModule /></ProtectedRoute>} />
            <Route path="/certificates" element={<ProtectedRoute><CertificateManager /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/customer-orders" element={<ProtectedRoute><CustomerOrderHistory /></ProtectedRoute>} />
            
            {/* Admin Routes */}
            <Route path="/admin/users" element={<ProtectedRoute requireAdmin><AdminUsers /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;